export default {
    euro(value) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2
        });
        return formatter.format(parseFloat(value));
    }
}